var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { Prop, Emit, Watch } from 'vue-property-decorator';
import { CaseAssistService } from '~/services/domain-service/case-assist.service.ts';
import DistributionPattern from '~/components/distribution-common/distribution-pattern.vue';
import { CaseAssitCaseService } from '~/services/domain-service/case-assist-case.service.ts';
var AssistCaseConfirmDistribution = /** @class */ (function (_super) {
    __extends(AssistCaseConfirmDistribution, _super);
    function AssistCaseConfirmDistribution() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * 查询实体
         */
        _this.model = {
            distributeCategory: 'TO_COLLECTOR',
            commonFlag: 'YES',
            distributeMode: 'BY_CUSTOMIZE',
            distributeNumber: [],
            caseAssistIds: [],
            analyseId: '',
        };
        /**
         * table数据源
         */
        _this.userDataSet = [];
        return _this;
    }
    Object.defineProperty(AssistCaseConfirmDistribution.prototype, "isCustomerDistribution", {
        /**
         * 是否自定义分配
         */
        get: function () {
            return this.model.distributeMode === 'BY_CUSTOMIZE';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssistCaseConfirmDistribution.prototype, "inputMax", {
        /**
         * 输入框最大值
         */
        get: function () {
            return this.model.caseIds.length;
        },
        enumerable: false,
        configurable: true
    });
    AssistCaseConfirmDistribution.prototype.refreshList = function () { };
    AssistCaseConfirmDistribution.prototype.onDistributeModeChange = function (val) {
        this.reviewDistributeCase();
    };
    AssistCaseConfirmDistribution.prototype.distributionDataChange = function (value) {
        if (!value)
            return;
        this.userDataSet = value.selectedUser;
        this.model.userIds = value.selectedUser.map(function (v) { return v.id; });
        this.model.caseIds = value.selectedCase.map(function (v) { return v.caseId; });
        this.model.caseAssistIds = value.selectedCase.map(function (v) { return v.id; });
        this.reviewDistributeCase();
    };
    /**
     * 获取预览分案结果
     */
    AssistCaseConfirmDistribution.prototype.reviewDistributeCase = function () {
        var _this = this;
        this.caseAssitCaseService.previewCaseAssist(this.model).subscribe(function (data) {
            _this.userDataSet = data.resDistModel || [];
            _this.model.analyseId = data.analyseId;
        }, function (err) {
            _this.resetDistributionModel();
        });
    };
    //取消
    AssistCaseConfirmDistribution.prototype.cancle = function () {
        this.resetDistributionModel();
    };
    //上一步
    AssistCaseConfirmDistribution.prototype.back = function () {
        this.resetDistributionModel();
    };
    //确定
    AssistCaseConfirmDistribution.prototype.next = function () {
        var _this = this;
        this.model.distributeNumber = this.userDataSet.map(function (v) { return parseInt(v.num); });
        this.caseAssitCaseService.confirmDistributeCase(this.model).subscribe(function (data) {
            _this.$message.success('分配成功');
            _this.cancle();
            _this.refreshList();
        });
    };
    /**
     * 初始化查询实体基础信息
     */
    AssistCaseConfirmDistribution.prototype.resetDistributionModel = function () {
        this.model.distributeMode = 'BY_CUSTOMIZE';
        this.model.distributeNumber = [];
        this.model.analyseId = '';
    };
    __decorate([
        Dependencies(PageService)
    ], AssistCaseConfirmDistribution.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CaseAssitCaseService)
    ], AssistCaseConfirmDistribution.prototype, "caseAssitCaseService", void 0);
    __decorate([
        Dependencies(CaseAssistService)
    ], AssistCaseConfirmDistribution.prototype, "caseAssistService", void 0);
    __decorate([
        Prop({ required: true })
    ], AssistCaseConfirmDistribution.prototype, "distributionData", void 0);
    __decorate([
        Emit('refreshList')
    ], AssistCaseConfirmDistribution.prototype, "refreshList", null);
    __decorate([
        Watch('model.distributeMode')
    ], AssistCaseConfirmDistribution.prototype, "onDistributeModeChange", null);
    __decorate([
        Watch('distributionData', { immediate: true })
    ], AssistCaseConfirmDistribution.prototype, "distributionDataChange", null);
    __decorate([
        Emit('close')
    ], AssistCaseConfirmDistribution.prototype, "cancle", null);
    __decorate([
        Emit('back')
    ], AssistCaseConfirmDistribution.prototype, "back", null);
    AssistCaseConfirmDistribution = __decorate([
        Component({
            components: {
                DistributionPattern: DistributionPattern,
            },
        })
    ], AssistCaseConfirmDistribution);
    return AssistCaseConfirmDistribution;
}(Vue));
export default AssistCaseConfirmDistribution;
